<div class="common-forms-select {{cssClass}}" commonKeyboardList>
    <div class="select form-group-inline" (click)="toggleDropdown()"
         cdkOverlayOrigin
         #origin="cdkOverlayOrigin"
         [class.open]="(isOpen$ | async)"
         [class.close]="!(isOpen$ | async)">
        <ng-content></ng-content>
    </div>
</div>

<ng-template
    cdk-connected-overlay
    cdkConnectedOverlayHasBackdrop
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayPositions]="overlayPosition"
    [cdkConnectedOverlayOpen]="(isOpen$ | async)"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    (backdropClick)="close()"
    (detach)="close()">
    <div [@dropdownAnim]
        class="common-forms-select"
        commonKeyboardList
        commonKeyboardListNavArrow
        commonKeyboardListNavTab
        commonKeyboardSymbolSearch
        [commonKeyboardListSelectedItemId]="selectedItemId$ | async"
        (commonKeyboardListThresholdTop)="close()">
        <ul class="items-container {{cssClass}}"
            [class.scrollbar]="showScrollbar">
            <li *ngIf="showReset"
                class="select-items"
                commonKeyboardItem
                [commonKeyboardItemSearchable]="false"
                (click)="onReset()"
                (keydown.enter)="onReset()">
                <span>{{resetText}}</span>
            </li>
            <li *ngFor="let item of (options$ | async); let key = index"
                class="select-items"
                commonKeyboardItem
                [commonKeyboardItemId]="key"
                (click)="onSelected($event, key)"
                (keydown.enter)="onSelected($event, key)"
                (keydown.space)="onSelected($event, key)">
                <span>{{item.label}}</span>
            </li>
        </ul>
    </div>
</ng-template>
